import React, { useState } from "react";
import styles from "../Login/css/Login.module.css";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const language = useSelector((state: any) => state.language.value);
  const [email, setEmail] = useState("");

  // Translations
  const translations = {
    title: language === "RO" ? "Resetare Parolă" : "Password Reset",
    emailPlaceholder: language === "RO" ? "E-mail" : "E-mail",
    sendButton: language === "RO" ? "Trimite E-mail" : "Send E-mail",
    backButton: language === "RO" ? "Înapoi" : "Back",
    errors: {
      invalidEmail:
        language === "RO"
          ? "Adresa de email nu este validă"
          : "Invalid email address",
      emptyEmail:
        language === "RO"
          ? "Vă rugăm introduceți adresa de email"
          : "Please enter your email address",
    },
    success:
      language === "RO"
        ? "Email-ul de resetare a fost trimis cu succes!"
        : "Password reset email has been sent successfully!",
  };

  const notify = (message: string, type: "success" | "error") => {
    toast[type](message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSendEmail = async () => {
    if (!email) {
      notify(translations.errors.emptyEmail, "error");
      return;
    }

    if (!validateEmail(email)) {
      notify(translations.errors.invalidEmail, "error");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/auth/forgot-password`,
        { email }
      );

      if (response.status === 200) {
        notify(translations.success, "success");
        setEmail(""); // Clear the email field after successful send
      }
    } catch (err: any) {
      notify(
        err.response?.data?.message ||
          (language === "RO"
            ? "A apărut o eroare. Vă rugăm încercați din nou."
            : "An error occurred. Please try again."),
        "error"
      );
    }
  };

  const handleBack = () => {
    navigate("/login");
  };

  return (
    <div className={styles.productContainer}>
      <div className={styles.productInfo}>
        <ToastContainer />
        <div
          className={styles.frame}
          style={{ width: "100%", maxWidth: "480px" }}
        >
          <span className={styles.productTitle7}>{translations.title}</span>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.inputField}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      height: "inherit",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                  }}
                  hiddenLabel
                  id="filled-hidden-label-normal"
                  placeholder={translations.emailPlaceholder}
                  variant="filled"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <button className={styles.buttonE} onClick={handleSendEmail}>
              <span className={styles.addToCartF}>
                {translations.sendButton}
              </span>
            </button>
            <button
              className={styles.buttonE}
              onClick={handleBack}
              style={{
                background: "transparent",
                border: "1px solid #517059",
              }}
            >
              <span className={styles.addToCartF} style={{ color: "#517059" }}>
                {translations.backButton}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
